import React from 'react'

const BkFlowEditRateField = (props) => {
	const {
		currentRateCode,
		handleRateCode,
		hotelLabels
	} = props

	let baseClassNames = 'bk-flow-edit-stay__rate-code'

	if (process.env.REACT_APP_COMPONENT_EDIT_STAY_RATE_CODE_FORMAT === 'uppercase') {
		baseClassNames = 'bk-flow-edit-stay__rate-code u-text-uppercase'
	}

	return (
		<div className="bk-flow-edit-stay__rate-field">
			<label
				className="u-element-hidden"
				htmlFor="rateCode"
				id="rateCodeLabel"
			>
				{ hotelLabels && hotelLabels.rateGroupCodeLabel ? hotelLabels.rateGroupCodeLabel : 'Group ID / Rate Code' }
			</label>
			<input
				type="text"
				name="rateCode"
				className={baseClassNames}
				placeholder={ hotelLabels && hotelLabels.rateGroupCodeLabel ? hotelLabels.rateGroupCodeLabel : 'Group ID / Rate Code' }
				value={ currentRateCode }
				onChange={ e => handleRateCode(e.target.value) }
				aria-labelledby="rateCodeLabel"
			 />
		</div>
	)
}


export default BkFlowEditRateField


// WEBPACK FOOTER //
// ./src/components/edit/rates/BkFlowEditRateField.js